import angular from 'angular';
import template from './sidebar-logo.html';
import './sidebar-logo.scss';
import { UserSubscriptionType } from '../../../modules/core/constants';
import { isDefaultLogo } from '../../utils/institution-logo';
class SidebarLogoController {
    constructor($rootScope, institutionHelper, growthbookFactory) {
        this.$rootScope = $rootScope;
        this.institutionHelper = institutionHelper;
        this.growthbookFactory = growthbookFactory;
    }
    $onInit() {
        void this.setLogoUrl();
        this.$rootScope.$on('institutionThemeUpdate', async () => this.setLogoUrl({ isUpdate: true }));
    }
    $onChanges() {
        void this.setLogoUrl({ isUpdate: true });
    }
    /**
     * Clinic user should be displayed as "free" if there is no current institution
     */
    async setLogoUrl({ isUpdate = false } = {}) {
        const currentInstitution = isUpdate
            ? await this.institutionHelper.getCurrentInstitution()
            : this.currentInstitution;
        switch (true) {
            case !this.isInstitution() &&
                this.planType === UserSubscriptionType.Clinic:
                this.logoUrl = '/assets/icons/legacy/logo-horizontal-free.png';
                break;
            case this.isInstitution() && Boolean(currentInstitution.logoHorizontal): {
                this.logoUrl = currentInstitution.logoHorizontal;
                break;
            }
            case [UserSubscriptionType.Pro, UserSubscriptionType.Trial].includes(this.planType):
                this.logoUrl = '/assets/icons/legacy/logo-horizontal-pro.png';
                break;
            case this.planType === UserSubscriptionType.Free:
                this.logoUrl = '/assets/icons/legacy/logo-horizontal-free.png';
                break;
            default:
                this.logoUrl = '/assets/images/icons/logo-horizontal.png';
        }
        this.altText = this.getAltText();
    }
    isInstitution() {
        return Boolean(this.currentInstitution?.id);
    }
    getAltText() {
        return this.isInstitution() &&
            !isDefaultLogo(this.currentInstitution?.logoHorizontal)
            ? `${this.currentInstitution.name} logo`
            : 'doxy.me logo';
    }
}
const sidebarLogo = {
    template,
    bindings: {
        planType: '<',
        currentInstitution: '<',
    },
    controller: SidebarLogoController,
};
export default angular
    .module('doxy.common.components.sidebarLogo', [])
    // sidebar-logo
    .component('sidebarLogo', sidebarLogo).name;
